import React from 'react';
import { motion } from 'framer-motion';

const SimpleProcess = () => {
  const steps = [
    {
      num: "1",
      title: "Research",
      desc: "Find high-intent keywords where video wins."
    },
    {
      num: "2",
      title: "Production",
      desc: "Script & produce for discovery."
    },
    {
      num: "3",
      title: "Publish",
      desc: "On our owned authority channels."
    },
    {
      num: "4",
      title: "Scale",
      desc: "Driving traffic month after month."
    }
  ];

  return (
    <section className="relative py-24 bg-[#0B0F19] overflow-hidden border-b border-white/5">
      {/* Subtle red/purple ambient glow matching the screenshot */}
      <div className="absolute top-0 left-1/2 w-full max-w-3xl h-[400px] bg-red-900/10 blur-[150px] rounded-full pointer-events-none -translate-x-1/2 -translate-y-1/2"></div>
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-4xl md:text-5xl font-bold text-white mb-6 tracking-tight"
          >
            Simple process
          </motion.h2>
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-slate-300 text-lg md:text-xl space-y-2"
          >
            <p>A proven system. No guessing. No experiments.</p>
            <p className="font-bold text-white">Compounding results.</p>
          </motion.div>
        </div>

        {/* Process Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, idx) => (
            <motion.div 
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.1 }}
              className="glass-card p-10 rounded-2xl border-white/5 bg-[#14161f] flex flex-col items-center text-center hover:bg-[#1a1c27] transition-colors duration-300"
            >
              {/* Red Number Badge */}
              <div className="w-16 h-16 rounded-[1.25rem] bg-[#ef4444] flex items-center justify-center text-white text-2xl font-bold mb-8 shadow-[0_0_30px_rgba(239,68,68,0.2)]">
                {step.num}
              </div>
              
              <h3 className="text-xl font-bold text-white mb-4">{step.title}</h3>
              <p className="text-slate-400 text-sm md:text-[15px] leading-relaxed font-medium">
                {step.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SimpleProcess;